import { render, staticRenderFns } from "./manageRecruitment.vue?vue&type=template&id=baffe886&"
import script from "./manageRecruitment.vue?vue&type=script&lang=js&"
export * from "./manageRecruitment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports